import { StatusComponentProps } from './types';

import * as Styled from './StatusComponents.styles';

export const StatusComponent = ({ status, options }: StatusComponentProps) => (
	<Styled.StatusContainer color={options[status].color}>{options[status].text}</Styled.StatusContainer>
);
